import { render, staticRenderFns } from "./quote-text.vue?vue&type=template&id=9c67fbb2&"
import script from "./quote-text.js?vue&type=script&lang=js&"
export * from "./quote-text.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports